import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/chat/NavbarTop.css';
import Logo from './../../components/logo.png'
import * as globals from './../../components/GlobalScripts.js';

const NavbarTop = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setMenuIsOpen] = useState(false);

    useEffect(() => {
        if(globals.isAuthenticated()){
            globals.validateSession();
        }
    }, [location]);

    const toggleMenuDropdown = () => {
        setMenuIsOpen(!isMenuOpen);
    };

    const handleLogout = async () => {
        localStorage.removeItem('session_id');
        localStorage.removeItem('keylogin');
        localStorage.removeItem('code_confirm');
        localStorage.removeItem('user');

        localStorage.removeItem('formDataSearch');
        navigate(`/login`);
    };

    return (
        <>
        <nav className="navbar-top">
            <div className="navs">
                <div className="primary-nav">
                    <div>
                        <Link to="/">
                            <img className='logo' src={Logo} alt='Logo' />
                        </Link>
                        <Link to="/">Inicio</Link>
                        <Link to="/cliente">Perfil de cliente</Link>
                        <Link to="/profesional">Perfil profesional</Link>
                        <Link to="/chat/view">Conversaciones</Link>
                    </div>
                    <div>
                        <button onClick={handleLogout} className="button-primary">Cerrar sesión</button>
                    </div>
                </div>
                
                <div className="primary-nav-mobile">
                    <div>
                        <button onClick={toggleMenuDropdown} className="container-icon cursor-pointer">
                            <svg width="40" height="40" viewBox="0 0 76 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 60.125C0.5 59.2962 0.829241 58.5013 1.41529 57.9153C2.00134 57.3292 2.7962 57 3.625 57H72.375C73.2038 57 73.9987 57.3292 74.5847 57.9153C75.1708 58.5013 75.5 59.2962 75.5 60.125C75.5 60.9538 75.1708 61.7487 74.5847 62.3347C73.9987 62.9208 73.2038 63.25 72.375 63.25H3.625C2.7962 63.25 2.00134 62.9208 1.41529 62.3347C0.829241 61.7487 0.5 60.9538 0.5 60.125ZM0.5 41.375C0.5 40.5462 0.829241 39.7513 1.41529 39.1653C2.00134 38.5792 2.7962 38.25 3.625 38.25H72.375C73.2038 38.25 73.9987 38.5792 74.5847 39.1653C75.1708 39.7513 75.5 40.5462 75.5 41.375C75.5 42.2038 75.1708 42.9987 74.5847 43.5847C73.9987 44.1708 73.2038 44.5 72.375 44.5H3.625C2.7962 44.5 2.00134 44.1708 1.41529 43.5847C0.829241 42.9987 0.5 42.2038 0.5 41.375ZM0.5 22.625C0.5 21.7962 0.829241 21.0013 1.41529 20.4153C2.00134 19.8292 2.7962 19.5 3.625 19.5H72.375C73.2038 19.5 73.9987 19.8292 74.5847 20.4153C75.1708 21.0013 75.5 21.7962 75.5 22.625C75.5 23.4538 75.1708 24.2487 74.5847 24.8347C73.9987 25.4208 73.2038 25.75 72.375 25.75H3.625C2.7962 25.75 2.00134 25.4208 1.41529 24.8347C0.829241 24.2487 0.5 23.4538 0.5 22.625ZM0.5 3.875C0.5 3.0462 0.829241 2.25134 1.41529 1.66529C2.00134 1.07924 2.7962 0.75 3.625 0.75H72.375C73.2038 0.75 73.9987 1.07924 74.5847 1.66529C75.1708 2.25134 75.5 3.0462 75.5 3.875C75.5 4.7038 75.1708 5.49866 74.5847 6.08471C73.9987 6.67076 73.2038 7 72.375 7H3.625C2.7962 7 2.00134 6.67076 1.41529 6.08471C0.829241 5.49866 0.5 4.7038 0.5 3.875Z" fill="black" />
                            </svg>
                        </button>
                    </div>
                </div>

                {isMenuOpen && (
                    <div className="secundary-nav">
                        <div>
                            <button onClick={toggleMenuDropdown} className="close-menu cursor-pointer">X</button>
                            <Link to="/">Inicio</Link>
                            <Link to="/cliente">Perfil de cliente</Link>
                            <Link to="/profesional">Perfil profesional</Link>
                            <Link to="/chat/view">Conversaciones</Link>
                        </div>
                        <div>
                            <button onClick={handleLogout} className="close-menu cursor-pointer">Cerrar sesión</button>
                        </div>
                    </div>
                )}
            </div>
        </nav>
        </>
    );
};

export default NavbarTop;